module.exports = __webpack_public_path__ + "media/widgets/fastweb-app_600x500-0f18d8d1.jpg";